import { memo } from "react";

import { ProductSelector as ProductSelectorData } from "./ProductSelector.data";
import { ProductSelectorProvider } from "./ProductSelectorContext";

type Props = {
  formatBtnText: {
    available: string;
    soldOut: string;
    waitlisted: string;
  };
  id?: string;
  selectOption: string;
};
const ProductSelectorRootBase = ({
  formatBtnText,
  id,
  selectOption,
}: Props) => {
  return (
    <ProductSelectorProvider id={id}>
      <ProductSelectorData
        formatBtnText={formatBtnText}
        selectOption={selectOption}
      />
    </ProductSelectorProvider>
  );
};

export const ProductSelector = memo(ProductSelectorRootBase);
